import React, { Component } from "react";
import logo from '../assets/image/logo.png';

export default class Navbar extends Component {
  
  render() {
    return (
        <div className='navbar w-full absolute top-10 max-w-[1440px] px-2 md:px-10 flex justify-between items-center space-x-10'>
            <img className='w-[200px] md:w-[280px] md:h-[40px] xl:w-[352px] xl:h-[50px]' src={logo}/>
            <div className='hidden lg:flex justify-between w-full text-[18px] text-white'>
                <div className="font-bold text-yellow-300">HOME</div>
                <div >ABOUT US</div>
                <div >DISCOGRAPHY</div>
                <div >EVENT</div>
                <div >ARTIST</div>
                <div >NEWS</div>
            </div>
            <button className='px-5 py-2 bg-[#f9fd11] text-black text-[18px]  font-semibold'>BUY&nbsp;$LALA</button>
        </div>
    );
  }
}
